





























































import { Component, Vue } from "vue-property-decorator";
import BusinessBranch from "@/components/BusinessBranch/BusinessBranch";
import IndicatorCard from "@/components/IndicatorCard";
import BiBusinessInteractionChart from "@/components/BiBusinessInteractionChart";
import BiPieChart from "@/components/BiPieChart";
import BieDonut from "@/components/BiDonut";
import BiMap from "@/components/BiMap";
import Intersection from "@/components/Intersection";
import axios from "axios";

import { BusinessData } from "@/types";
import { DonutData } from "../components/BiDonut.vue";
import { PieData } from "../components/BiPieChart.vue";
import VueGtag from "vue-gtag";

@Component({
  name: "BiMsb",

  components: {
    BusinessBranch,
    IndicatorCard,
    BiBusinessInteractionChart,
    BiPieChart,
    BieDonut,
    BiMap,
    Intersection,
  },
})
export default class BiMsb extends Vue {
  smeActivitiesData = [{}, {}];
  donutData: DonutData[] = [];
  volumeData: PieData[] = [];
  companySizeData: PieData[] = [];
  smeGenderData: PieData[] = [];
  companyArea: BusinessData[] = [];
  indicatorsData: any[] = [{}, {}];
  mapData = null;
  filledProfile = null;
  trackOnce = false;

  objectToData(object: { [key: string]: number }) {
    return Object.entries(object).map(([key, value]) => ({
      value,
      label: key,
    }));
  }
  trackAnalytic() {
    if (this.trackOnce === false) {
      this.$gtag.event("BI_sme_map");
      return (this.trackOnce = true);
    }
  }
  async mounted() {
    console.log(this.$gtag)
    this.$gtag.pageview({page_path: "/bi_sme"});
    Promise.all([
      axios
        .get(`${process.env.VUE_APP_API_URL}analytics/site-visitors-count`)
        .then((res: any) => res.data),
      axios
        .get(`${process.env.VUE_APP_API_URL}analytics/smes-count`)
        .then((res: any) => res.data),
      axios.get(
        `${process.env.VUE_APP_API_URL}analytics/filled-profile-smes-count`
      ),
      // axios.get(`${process.env.VUE_APP_API_URL}analytics/cooperations-count`),
      axios.get(`${process.env.VUE_APP_API_URL}analytics/sme-company-areas`),
    ]).then(([visits, sme, profile, companyAreas]) => {
      this.indicatorsData = [
        // {
        //   title: "Заповнили свій профіль",
        //   count: profile.data.total,
        //   data: profile.data.values || [100, 200, 80, 359, 210, 100],
        //   gradient: "dark"
        // },
        // {
        //   title: "Надіслали бріф експерту",
        //   count: cooperations.data.total || 231,
        //   data: cooperations.data.values || [28, 44, 8, 105, 218],
        //   gradient: "dark"
        // },
        {
          title: `${this.$t("msb.platform_visits")}`,
          count: visits.total,
          data: visits.values,
          gradient: "light",
        },
        {
          title: `${this.$t("msb.sme_total")}`,
          count: sme.total,
          data: sme.values,
          gradient: "light",
        },
      ];
      this.filledProfile = profile.data.total;
      this.companyArea = this.objectToData(companyAreas.data.values).map(
        (item) => ({
          title: item.label,
          percent: item.value,
        })
      );
    });
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/regional-smes-count`)
      .then((res) => (this.mapData = res.data.values));
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/sme-company-types`)
      .then((res) => (this.donutData = this.objectToData(res.data.values)));

    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/sme-company-revenues`)
      .then((res) => (this.volumeData = this.objectToData(res.data.values)));
    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/sme-company-sizes`)
      .then(
        (res) => (this.companySizeData = this.objectToData(res.data.values))
      );

    axios
      .get(`${process.env.VUE_APP_API_URL}analytics/sme-genders`)
      .then((res) => {
        this.smeGenderData = this.objectToData(res.data.values);
        const newLabel = ["Жінок", "Чоловіків"];
        this.smeGenderData.map((item, i) => (item.label = newLabel[i]));
      });

    Promise.all([
      axios.get(
        `${process.env.VUE_APP_API_URL}analytics/favorite-tasks-average-count`
      ),
      axios.get(
        `${process.env.VUE_APP_API_URL}analytics/favorite-experts-average-count`
      ),
    ]).then(([tasks, experts]) => {
      this.smeActivitiesData = [
        {
          title: `${this.$t("msb.sme_activity_indicator_1")}`,
          count: tasks.data.total.toFixed(1),
          data: [],
        },
        {
          title: `${this.$t("msb.sme_activity_indicator_2")}`,
          count: experts.data.total.toFixed(1),
          data: [],
        },
      ];
    });

    await console.log(this.smeGenderData);
  }
}
